import Vue from "vue";
import Router from "vue-router";

import store from "./store";

import App from "./App";
import Login from "./views/Login";
import Home from "./views/Home";
import Playlist from "./views/Playlist";
import Playlists from "./views/Playlists";
import NewPlaylist from "./views/NewPlaylist";
import EditPlaylistItem from "./views/EditPlaylistItem";
import NewPlaylistItem from "./views/NewPlaylistItem";
import Songs from "./views/Songs";
import SongsTable from "./views/SongsTable";
import Song from "./views/Song";
import NewSong from "./views/NewSong";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    // Each of these routes are loaded asynchronously, when a user first navigates to each corresponding endpoint.
    // The route will load once into memory, the first time it's called, and no more on future calls.
    // This behavior can be observed on the network tab of your browser dev tools.
    {
      path: "",
      name: "root",
      redirect: "/",
      component: App,
      meta: {
        title: "Kithara"
      },
      children: [
        {
          path: "login",
          name: "login",
          component: Login
        },
        {
          path: "",
          name: "home",
          redirect: "/",
          component: Home,
          beforeEnter: guardRoute,
          children: [
            {
              path: "",
              name: "songs",
              component: Songs
            },
            {
              path: "/table",
              name: "table",
              component: SongsTable
            },
            {
              path: "/songs/:id",
              name: "song",
              component: Song
            },
            {
              path: "/new-song",
              name: "new-song",
              component: NewSong
            },
            {
              path: "/playlists",
              name: "playlists",
              component: Playlists
            },
            {
              path: "/playlists/:playlistId",
              name: "playlist",
              component: Playlist
            },
            {
              path: "/new-playlist",
              name: "new-playlist",
              component: NewPlaylist
            },
            {
              path: "/playlists/:playlistId/edit-item/:playlistItemId",
              name: "edit-playlist-item",
              component: EditPlaylistItem
            },
            {
              path: "/playlists/:playlistId/new-item",
              name: "new-playlist-item",
              component: NewPlaylistItem
            }
          ],
          meta: {
            htmlClass: "has-navbar-fixed-top"
          }
        }
      ]
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
});

function guardRoute(to, from, next) {
  // work-around to get to the Vuex store (as of Vue 2.0)
  // const auth = router.app.$options.store.state.auth

  if (!store.getters.isLoggedIn) {
    next({
      path: "/login",
      query: { redirect: to.fullPath }
    });
  } else {
    next();
  }
}

// https://alligator.io/vuejs/vue-router-modify-head/
// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.title);

  const nearestWithHTMLClass = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.htmlClass);
  if (nearestWithHTMLClass) {
    document
      .querySelector("html")
      .setAttribute("class", nearestWithHTMLClass.meta.htmlClass);
  } else {
    document.querySelector("html").setAttribute("class", "");
  }

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll("[data-vue-router-controlled]")).map(
    el => el.parentNode.removeChild(el)
  );

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags
    .map(tagDef => {
      const tag = document.createElement("meta");

      Object.keys(tagDef).forEach(key => {
        tag.setAttribute(key, tagDef[key]);
      });

      // We use this to track which meta tags we create, so we don't interfere with other ones.
      tag.setAttribute("data-vue-router-controlled", "");

      return tag;
    })
    // Add the meta tags to the document head.
    .forEach(tag => document.head.appendChild(tag));

  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router.js